import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Badge from './Badge'
import { numberFormat } from './../utils/number-format-util'

const PurchaseDetailsBlock = ({
    testId,
    name,
    order,
    value,
    amount = false,
    percentage = false,
    label = false,
    moLabel = false,
    mosLable = false,
    dealerLabel = false,
    yrLable = false
}) => {
    const { t } = useTranslation()

    return (
        <Box
            sx={{
                display: 'grid',
                alignItems: 'end'
            }}
        >
            <Typography
                tabIndex={0}
                component="div"
                color="common.gray.light"
                data-testid={`${testId}-label`}
                sx={{
                    display: 'inline-flex',
                    whiteSpace: 'nowrap',
                    typography: 'regularBody3'
                }}
            >
                {name}
                <Badge badgeContent={order}></Badge>
            </Typography>

            <Box
                tabIndex={0}
                data-testid={`${testId}-value`}
                sx={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '5px'
                }}
            >
                <Typography
                    component="span"
                    color="common.charcoal.main"
                    fontWeight="bold"
                    sx={{
                        typography: { xs: 'mediumTitle' }
                    }}
                >
                    {amount && <>${numberFormat(value)}</>}
                    {percentage && <>{value}%</>}
                    {label && <>{value}</>}
                    {yrLable && <>{numberFormat(value)}</>}
                </Typography>

                {moLabel && (
                    <Typography
                        color="common.charcoal.main"
                        component="span"
                        sx={{
                            typography: 'regularBody1'
                        }}
                    >
                        /{t('mo')}
                    </Typography>
                )}

                {mosLable && (
                    <Typography
                        color="common.charcoal.main"
                        component="span"
                        sx={{
                            typography: 'regularBody1'
                        }}
                    >
                        {t('mos')}
                    </Typography>
                )}

                {yrLable && (
                    <Typography
                        color="common.charcoal.main"
                        component="span"
                        sx={{
                            typography: 'regularBody1'
                        }}
                    >
                        /{t('yr')}
                    </Typography>
                )}
            </Box>

            {dealerLabel && (
                <Typography
                    component="div"
                    tabIndex={0}
                    color="common.gray.light"
                    data-testid="more-information"
                    sx={{
                        display: 'inline-flex',
                        textAlign: 'center',
                        mt: 3,
                        typography: 'regularBody3'
                    }}
                >
                    {t('check_with_dealer')}
                </Typography>
            )}
        </Box>
    )
}

PurchaseDetailsBlock.propTypes = {
    testId: PropTypes.string,
    name: PropTypes.string,
    order: PropTypes.number,
    value: PropTypes.number,
    amount: PropTypes.bool,
    percentage: PropTypes.bool,
    label: PropTypes.bool,
    moLabel: PropTypes.bool,
    mosLable: PropTypes.bool,
    dealerLabel: PropTypes.bool,
    yrLable: PropTypes.bool
}

export default PurchaseDetailsBlock
